// 2026-06-11 SEO: occasion-specific gift landing pages targeting the
// gelegenheids-queries (vaderdag cadeau, cadeau voor hem/haar,
// verjaardagscadeau beleving) that the 4 category hubs in
// intent-config.js don't cover. An occasion cuts ACROSS categories
// (a vaderdag page mixes pretpark + stedentrip + wellness), so instead
// of the hubs' categoryFilter these landings carry an explicit curated
// list of voucher deals_ids in editorial order.
//
// NL-only (same mechanism as the branded voucher landings in
// _branded-voucher/voucher-landing-config.js): these queries are Dutch
// gift intents without DE/FR/UK equivalents, so the copy ships only in
// src/i18n/nl.json under cadeaubon.<occasion_snake>.* and each page.js
// sets nlOnly:true so non-NL TLDs emit robots noindex,follow.
//
// Copy passed scripts/seo-lint.sh (handbook) on 2026-06-11 with
// 0 fails / 0 warns.
//
// Fixronde 2 #1920 (03-11-2026): no voucher that is no longer sold: 115, 95,
// 128 and 244 are retired, so they left the curated lists; the live city trips
// 332 (Amsterdam) and 333 (Rome) took their place. `mentions` lists, per
// text block (benefit_N, section_N, faq_<name>), the vouchers it names. OccasionLandingShell shows such a block only while
// every voucher it names is on sale (in the live list, and not closed by
// isVoucherSaleClosed), so a retirement hides the copy that offers it.
//
// Fixronde 3 #1920: no price anchor in the copy or in these comments. The
// copy names no amount; a price comes only from the live voucher list. Meta
// title, meta description, intro and the price question (faq_price) name the
// lowest price of the vouchers this page shows (hub-price.js, the same price
// rule as the voucher page and the checkout), and no amount when that set is
// empty or the list fails.

export const OCCASION_LANDINGS = {
  vaderdag: {
    slug: "vaderdag",
    path: "/cadeaubon/vaderdag",
    // Father's Day (NL) 2026 = Sunday 21 June. Curated voor-hem mix:
    // theme parks first (Phantasialand / Efteling / Tropical Islands /
    // Disneyland), then city trips (Amsterdam, Rome) and the wellness
    // picks the copy calls out by name.
    dealsIds: ["92", "196", "176", "332", "333", "225", "181", "55", "229"],
    i18nNs: "cadeaubon.vaderdag",
    breadcrumbName: "Vaderdag cadeau",
    sectionCount: 5,
    mentions: {
      section_2: ["92", "196", "176"],
      section_3: ["332", "333"],
      section_4: ["225", "181", "55"],
      faq_what: ["196", "92", "332", "333"],
    },
    faqKeys: [
      "cadeaubon.vaderdag.faq_what.q",
      "cadeaubon.vaderdag.faq_what.a",
      "cadeaubon.vaderdag.faq_timing.q",
      "cadeaubon.vaderdag.faq_timing.a",
      "cadeaubon.vaderdag.faq_who.q",
      "cadeaubon.vaderdag.faq_who.a",
      "cadeaubon.vaderdag.faq_validity.q",
      "cadeaubon.vaderdag.faq_validity.a",
      "cadeaubon.vaderdag.faq_redeem.q",
      "cadeaubon.vaderdag.faq_redeem.a",
    ],
  },
  "voor-hem": {
    slug: "voor-hem",
    path: "/cadeaubon/voor-hem",
    // "cadeau voor hem / man": action + city first, wellness as the
    // counter-intuitive closer (mirrors the section order of the copy).
    dealsIds: ["92", "332", "333", "255", "176", "196", "225", "55"],
    i18nNs: "cadeaubon.voor_hem",
    breadcrumbName: "Cadeau voor hem",
    sectionCount: 5,
    mentions: {
      section_2: ["92", "196", "176"],
      section_3: ["332", "333", "255"],
      section_4: ["225", "55"],
      faq_what: ["332", "333", "92"],
      faq_choice: ["55"],
    },
    faqKeys: [
      "cadeaubon.voor_hem.faq_what.q",
      "cadeaubon.voor_hem.faq_what.a",
      "cadeaubon.voor_hem.faq_who.q",
      "cadeaubon.voor_hem.faq_who.a",
      "cadeaubon.voor_hem.faq_choice.q",
      "cadeaubon.voor_hem.faq_choice.a",
      "cadeaubon.voor_hem.faq_validity.q",
      "cadeaubon.voor_hem.faq_validity.a",
      "cadeaubon.voor_hem.faq_redeem.q",
      "cadeaubon.voor_hem.faq_redeem.a",
    ],
  },
  "voor-haar": {
    slug: "voor-haar",
    path: "/cadeaubon/voor-haar",
    // "cadeau voor haar / vrouw": the eight wellness vouchers on sale, plus
    // the Amsterdam city trip and the Harry Potter theater experience.
    dealsIds: ["225", "181", "249", "55", "246", "248", "245", "247", "332", "255"],
    i18nNs: "cadeaubon.voor_haar",
    breadcrumbName: "Cadeau voor haar",
    sectionCount: 5,
    mentions: {
      benefit_1: ["225", "181", "249", "55", "246", "248", "245", "247"],
      benefit_2: ["332", "255"],
      section_2: ["225", "181", "249", "55", "246", "248", "245", "247"],
      section_3: ["332"],
      section_4: ["255"],
      faq_what: ["225", "181", "249", "332", "255"],
      faq_resorts: ["225", "181", "249", "55", "246", "248", "245", "247"],
      faq_who: ["55"],
    },
    faqKeys: [
      "cadeaubon.voor_haar.faq_what.q",
      "cadeaubon.voor_haar.faq_what.a",
      "cadeaubon.voor_haar.faq_resorts.q",
      "cadeaubon.voor_haar.faq_resorts.a",
      "cadeaubon.voor_haar.faq_who.q",
      "cadeaubon.voor_haar.faq_who.a",
      "cadeaubon.voor_haar.faq_validity.q",
      "cadeaubon.voor_haar.faq_validity.a",
      "cadeaubon.voor_haar.faq_redeem.q",
      "cadeaubon.voor_haar.faq_redeem.a",
    ],
  },
  verjaardag: {
    slug: "verjaardag",
    path: "/cadeaubon/verjaardag",
    // "verjaardagscadeau beleving": broad mix for any jarige; family
    // parks first, then wellness, city trips and the theater experience.
    dealsIds: ["196", "229", "225", "55", "332", "333", "92", "176", "255"],
    i18nNs: "cadeaubon.verjaardag",
    breadcrumbName: "Verjaardagscadeau",
    sectionCount: 5,
    mentions: {
      section_2: ["196", "229", "225", "55", "332", "333", "255"],
      faq_what: ["196", "225", "332"],
    },
    faqKeys: [
      "cadeaubon.verjaardag.faq_what.q",
      "cadeaubon.verjaardag.faq_what.a",
      "cadeaubon.verjaardag.faq_lastminute.q",
      "cadeaubon.verjaardag.faq_lastminute.a",
      "cadeaubon.verjaardag.faq_price.q",
      "cadeaubon.verjaardag.faq_price.a",
      "cadeaubon.verjaardag.faq_validity.q",
      "cadeaubon.verjaardag.faq_validity.a",
      "cadeaubon.verjaardag.faq_redeem.q",
      "cadeaubon.verjaardag.faq_redeem.a",
    ],
  },
};

// Same hreflang shape as the branded NL-only landings: non-NL markets
// point at their /vouchers index instead of a Dutch occasion page.
export const OCCASION_ALTERNATE_PATHS = {
  "de-de": "/vouchers",
  "fr-fr": "/vouchers",
  "fr-be": "/vouchers",
  "en-gb": "/vouchers",
};

/**
 * May the text block `blockKey` (benefit_N, section_N, faq_<name>) show?
 * Only while every voucher it names (`occasion.mentions`) is in `onSale`,
 * the curated vouchers that are on sale now. A block that names no voucher
 * always shows.
 */
export function isOccasionBlockOnSale(occasion, blockKey, onSale) {
  const named = occasion?.mentions?.[blockKey];
  if (!Array.isArray(named) || named.length === 0) return true;
  const ids = new Set((Array.isArray(onSale) ? onSale : []).map((v) => String(v?.deals_id)));
  return named.every((id) => ids.has(String(id)));
}

/**
 * Pick the occasion's curated vouchers out of the live voucher list,
 * PRESERVING the curated order from dealsIds (not the BFF order).
 * Ids missing from the live list (voucher retired/unpublished) are
 * skipped silently so the page degrades to a shorter list instead of
 * rendering holes.
 */
export function filterVouchersForOccasion(vouchers, occasion) {
  if (!Array.isArray(vouchers) || !occasion) return [];
  const byId = new Map(
    vouchers
      .filter((v) => v && v.deals_id !== undefined && v.deals_id !== null)
      .map((v) => [String(v.deals_id), v]),
  );
  return occasion.dealsIds
    .map((id) => byId.get(String(id)))
    .filter(Boolean);
}
